import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link, IndexLink } from 'react-router';

class Manufacturer extends React.Component {
   render() {
      return (
         <div className="Manufacturer" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/manufacturer/" activeStyle={{ color: 'red' }} >Manufacturer</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to="/manufacturer/" activeStyle={{ color: 'red' }} >All</IndexLink>
                  </li>
                  <li>
                     <Link to="/manufacturer/new" activeStyle={{ color: 'red' }} >New</Link>
                  </li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

Manufacturer.propTypes = {
   children: PropTypes.object
};

export default Manufacturer;



/** WEBPACK FOOTER **
 ** ./src/components/Manufacturer/Manufacturer.js
 **/